var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-tip"},[_c('span',[_vm._v("拖拽")]),_c('span',{staticClass:"high-text"},[_vm._v("「 左侧标签 」")]),_c('span',[_vm._v("到")]),_c('span',{staticClass:"high-text"},[_vm._v("「 标签栏 」")]),_c('span',[_vm._v("和")]),_c('span',{staticClass:"high-text"},[_vm._v("「 统计栏 」")]),_c('span',[_vm._v("，拖拽后图表会自动显示")])])
}]

export { render, staticRenderFns }